// extracted by css-extract-rspack-plugin
export default {"chat":"u4w9z","topFade":"wt9u3"};